import { render, staticRenderFns } from "./isPro3.vue?vue&type=template&id=fa372404&scoped=true&"
import script from "./isPro3.vue?vue&type=script&lang=js&"
export * from "./isPro3.vue?vue&type=script&lang=js&"
import style0 from "./isPro3.vue?vue&type=style&index=0&id=fa372404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa372404",
  null
  
)

export default component.exports